import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { severityColors } from 'style/theme';

const getSeries = (data) => {
  const high = [];
  const medium = [];
  const low = [];
  const suggestion = [];
  const series = sortDictionary(data);

  series.forEach(([key, value]) => {
    high.push(value.high);
    medium.push(value.medium);
    low.push(value.low);
    suggestion.push(value.suggestion);
  });

  return [
    {
      name: 'HIGH',
      data: high
    },
    {
      name: 'MEDIUM',
      data: medium
    },
    {
      name: 'LOW',
      data: low
    },
    {
      name: 'SUGGESTION',
      data: suggestion
    }
  ];
};

const sortDictionary = (data) => {
  var drrsfagDict = {
    description: 0,
    role: 1,
    relationship: 2,
    state: 3,
    focus: 4,
    action: 5,
    general: 6
  };

  var sortedDrrasfg = [];
  var entries = Object.entries(data);
  var general = entries.filter((e) => e[0] == 'general')[0];
  entries = entries.filter((e) => e[0] !== 'general');
  entries.forEach(([key, value]) => {
    if (general) sortedDrrasfg.splice(drrsfagDict[key], 1, [key, value]);
  });
  sortedDrrasfg.push(general);
  return sortedDrrasfg;
};

const getOptions = (title, subtitle) => {
  return {
    colors: [severityColors.high, severityColors.medium, severityColors.low, severityColors.suggestion],
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
      stackType: 'normal'
    },
    plotOptions: {
      bar: {
        horizontal: false
      }
    },
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    title: {
      text: title,
      style: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#333'
      }
    },
    subtitle: {
      text: subtitle,
      align: 'left',
      offsetY: 20,
      style: {
        fontSize: '10px',
        color: '#000'
      }
    },
    xaxis: {
      categories: ['D', 'R', 'R', 'S', 'F', 'A', 'G']
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val;
        }
      }
    },
    fill: {
      opacity: 1
    },
    legend: {
      fontSize: '10px',
      offsetX: 220,
      offsetY: -265,
      markers: {
        radius: 0
      }
    },
    responsive: [
      {
        breakpoint: 1475,
        options: {
          title: {
            style: {
              fontSize: '14px'
            }
          },
          legend: {
            offsetX: 0,
            offsetY: 0
          }
        }
      },
      {
        breakpoint: 1300,
        options: {
          title: {
            style: {
              fontSize: '13px'
            }
          }
        }
      }
    ]
  };
};

export function StackBarChart({ title, subtitle, data }) {
  const [series, setSeries] = useState();
  const [options, setOptions] = useState();

  useEffect(() => {
    if (data) {
      setSeries(getSeries(data));
      setOptions(getOptions(title, subtitle));
    }
  }, [data]);

  return (
    <div class="chart">{series && <ReactApexChart options={options} series={series} type="bar" height={290} />}</div>
  );
}
